// extracted by mini-css-extract-plugin
module.exports = {"tab":"loader_tab__Zje7P","grid":"loader_grid___4fF0"};